import template from './surveys.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class SurveysViewModel
{
	constructor (page)
	{
		this.page = page;
		this.survey = ko.observableArray();
		this.survey_document = ko.observableArray();
		this.survey_id = ko.observable();
		this.employee_id = ko.observable();
	}

	submit(v, e)
	{
		this.page.send_survey_data_to_server(this.page.extract_survey_data(v.survey_questions));
		Grape.navigate('/employee/dashboard');
	}
}

class SurveysPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new SurveysViewModel(this);
		this.viewModel.employee_id(Utils.get_local_storage_nullable('employee_id'));
		
		if (this.viewModel.employee_id() == null || this.viewModel.employee_id() == 0)
			this.viewModel.employee_id(0);

		this.viewModel.survey_id(bindings.id);
		this.updateData();
	}

	init()
	{
		// update the page title
		document.title = tr('Complete Survey');
		window.current_page_title(tr('Complete Survey'));
	}

	updateData()
	{
		if (this.bindings.id == undefined)
			return;
		this.load_survey();
	}

	extract_generic_survey_data(question_params)
	{
		return {
			question_response: question_params.response,
			time_completed: question_params.time_completed
		};
	}

	// --------------
	// FUNCTION: Extract checkbox data
	extract_survey_checkbox_data(question_params)
	{
		let chkBoxResponse = '';
		_.each(question_params.options_list, (obj) => {
			if (obj.option_checked == true)
				chkBoxResponse += obj.option_text + ', ';
		});
		return {
			question_response: chkBoxResponse
		};
	}

	// --------------
	// FUNCTION: Extract radiobox data
	extract_survey_radiobox_data(question_params)
	{
		let rdbBoxResponse = '';
		_.each(question_params.options_list, (obj) => {
			if (typeof obj.option_checked !== 'boolean')
				rdbBoxResponse = obj.option_text;
		});
		return {
			question_response: rdbBoxResponse
		};
	}

	// --------------
	// FUNCTION: Set response structure with id and time completed
	set_response(question)
	{
		return {
			question_id: question.question_id,
			question_response: ''
		};
	}

	extract_survey_data(survey)
	{
		let survey_result = [];

		_.each(survey, (question) => {
			let response = this.set_response(question);

			switch (question.question_type)
			{
				case 'survey_radiobox':
					Object.assign(response, this.extract_survey_radiobox_data(question.question_params));
					break;
				case 'survey_checkbox':
					Object.assign(response, this.extract_survey_checkbox_data(question.question_params));
					break;
				case 'survey_range':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
				case 'survey_textarea':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
				case 'survey_input':
					Object.assign(response, this.extract_generic_survey_data(question.question_params));
					break;
			}

			survey_result.push(response);
		});

		return survey_result;
	}

	// LOGIC: Send survey data to server
	async send_survey_data_to_server(server_data)
	{
		let device_uuid = localStorage.getItem('session_id');
		_.forEach(server_data, async (item) => {
			if (item.question_response != '')
			{
				let res = await Grape.fetches.postJSON('/surveys/save_survey_answer', {
					survey_id: this.bindings.id,
					survey_items_id: item.question_id,
					answer: item.question_response,
					user_id: device_uuid,
					employee_id: this.viewModel.employee_id(),
					public: this.viewModel.survey().public
				});
			}
		});
	};

	async load_survey()
	{
		let user_id = '';
		let res_surveys = await Grape.fetches.getJSON('/api/record', {
			table: 'v_surveys',
			schema: 'savanna',
			limit: 5000,
			filter: [{
				value: this.viewModel.employee_id(), operand: '=', field: 'employee_id' }, {
					value: ['Sent', 'Read', 'Done'],
					operand: 'IN',
					field: 'survey_status'
				}, { value: this.bindings.id, operand: '=', field: 'survey_id' 
			}]
		});
		if (res_surveys.status !== 'ERROR')
		{
			let boolCheck = false;
			if (res_surveys.records[0].public == false)
			{
				let res_anon_surveys = await Grape.fetches.getJSON('/api/record', {
					table: 'v_anonymous_surveys',
					schema: 'savanna',
					limit: 5000,
					filter: [
						{ value: res_surveys.records[0].survey_id, op: '=', field: 'survey_id' },
						{ value: user_id, op: '=', field: 'user_id' }, { value: true, op: '=', field: 'active' }
					]
				});
				if (!res_anon_surveys.records)
					return;
				if (res_anon_surveys.records.length > 0)
				{
					boolCheck = true;
					_.each(res_anon_surveys.records[0].survey_questions, (items) => {
						items.question_params =
						{
							question_description: items.question_params[0].question_description || '',
							response: items.question_params[0].response || '',
							options_list: items.question_params[0].options_list || '',
							response: items.question_params[0].response || '',
							min_value: items.question_params[0].min_value || 0,
							max_value: items.question_params[0].max_value || 0,
							default_min_value: items.question_params[0].default_min_value || 0,
							default_max_value: items.question_params[0].default_max_value || '',
							step: items.question_params[0].step || 1,
							dual: items.question_params[0].dual || false,
							time_completed: '',
							checkbox_response: [],
							radiobutton_response: '',
							radiobox_name: 'radiobox_' + Math.random().toString(36).substring(7),
							slider_range_id: 'range_' + Math.random().toString(36).substring(7)
						};
					});

					this.viewModel.survey(res_anon_surveys.records[0]);
				}
			}

			if (boolCheck == false)
			{
				_.each(res_surveys.records[0].survey_questions, (items) => {
					items.question_params =
					{
						question_description: items.question_params[0].question_description || '',
						options_list: items.question_params[0].options_list || '',
						response: items.question_params[0].response || '',
						min_value: items.question_params[0].min_value || 0,
						max_value: items.question_params[0].max_value || 0,
						default_min_value: items.question_params[0].default_min_value || 0,
						default_max_value: items.question_params[0].default_max_value || '',
						step: items.question_params[0].step || 1,
						dual: items.question_params[0].dual || false,
						time_completed: '',
						checkbox_response: [],
						radiobutton_response: '',
						radiobox_name: 'radiobox_' + Math.random().toString(36).substring(7),
						slider_range_id: 'range_' + Math.random().toString(36).substring(7),
						checkbox_name: 'checkbox_' + Math.random().toString(36).substring(7)
					};
				});
				this.viewModel.survey(res_surveys.records[0]);
			}
		}

		// GET Document
		let res = await Grape.fetches.getJSON('/surveys/get_document/', { survey_id: this.bindings.id });
		if (res.status !== 'ERROR')
			this.viewModel.survey_document(res);
	}
}

export default {
	route: '[/]surveys/survey/:id',
	page_class: SurveysPage,
	template: template,
	template_filename: 'translation/surveys'
};
